import { CprState, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Credential Process Request State`;

export type CPCprStateLocs =
	| 'CPCprStateEnumBroadcast'
	| 'CPCprStateEnumComplete'
	| 'CPCprStateEnumError'
	| 'CPCprStateEnumQueued'
	| 'CPCprStateEnumRejected'
	| 'CPCprStateEnumRequested';

export type SPCprStateLocs =
	| 'SPCprStateEnumBroadcast'
	| 'SPCprStateEnumComplete'
	| 'SPCprStateEnumError'
	| 'SPCprStateEnumQueued'
	| 'SPCprStateEnumRejected'
	| 'SPCprStateEnumRequested';

export const cpCprStateEnumLocs: LocDefs<CPCprStateLocs> = {
	CPCprStateEnumBroadcast: {
		defaultValue: 'Broadcast',
		displayPath: `${dpRoot}|${CprState.Broadcast}`,
		description: `Credential process request state: '${CprState.Broadcast}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprStateEnumComplete: {
		defaultValue: 'Complete',
		displayPath: `${dpRoot}|${CprState.Complete}`,
		description: `Credential process request state: '${CprState.Complete}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}|${CprState.Error}`,
		description: `Credential process request state: '${CprState.Error}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}|${CprState.Queued}`,
		description: `Credential process request state: '${CprState.Queued}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}|${CprState.Rejected}`,
		description: `Credential process request state: '${CprState.Rejected}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
	CPCprStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}|${CprState.Requested}`,
		description: `Credential process request state: '${CprState.Requested}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'CP',
	},
};

export const spCprStateEnumLocs: LocDefs<SPCprStateLocs> = {
	SPCprStateEnumBroadcast: {
		defaultValue: 'Broadcast',
		displayPath: `${dpRoot}|${CprState.Broadcast}`,
		description: `Credential process request state: '${CprState.Broadcast}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprStateEnumComplete: {
		defaultValue: 'Complete',
		displayPath: `${dpRoot}|${CprState.Complete}`,
		description: `Credential process request state: '${CprState.Complete}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}|${CprState.Error}`,
		description: `Credential process request state: '${CprState.Error}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}|${CprState.Queued}`,
		description: `Credential process request state: '${CprState.Queued}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}|${CprState.Rejected}`,
		description: `Credential process request state: '${CprState.Rejected}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
	SPCprStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}|${CprState.Requested}`,
		description: `Credential process request state: '${CprState.Requested}'`,
		displayType: 'Content',
		feature: HubFeature.Credential,
		portal: 'SP',
	},
};

export const CPR_STATE_ENUM_LOCS = MapLocKeys<CPCprStateLocs | SPCprStateLocs>({
	...cpCprStateEnumLocs,
	...spCprStateEnumLocs,
});

export type CPCprStateEnumLocType = LocMap<CPCprStateLocs>;
export type SPCprStateEnumLocType = LocMap<SPCprStateLocs>;

export const cpCprStateKeys: { [key in CprState]: keyof CPCprStateEnumLocType } = {
	[CprState.Broadcast]: CPR_STATE_ENUM_LOCS.CPCprStateEnumBroadcast,
	[CprState.Complete]: CPR_STATE_ENUM_LOCS.CPCprStateEnumComplete,
	[CprState.Error]: CPR_STATE_ENUM_LOCS.CPCprStateEnumError,
	[CprState.Queued]: CPR_STATE_ENUM_LOCS.CPCprStateEnumQueued,
	[CprState.Rejected]: CPR_STATE_ENUM_LOCS.CPCprStateEnumRejected,
	[CprState.Requested]: CPR_STATE_ENUM_LOCS.CPCprStateEnumRequested,
};

export const spCprStateKeys: { [key in CprState]: keyof SPCprStateEnumLocType } = {
	[CprState.Broadcast]: CPR_STATE_ENUM_LOCS.SPCprStateEnumBroadcast,
	[CprState.Complete]: CPR_STATE_ENUM_LOCS.SPCprStateEnumComplete,
	[CprState.Error]: CPR_STATE_ENUM_LOCS.SPCprStateEnumError,
	[CprState.Queued]: CPR_STATE_ENUM_LOCS.SPCprStateEnumQueued,
	[CprState.Rejected]: CPR_STATE_ENUM_LOCS.SPCprStateEnumRejected,
	[CprState.Requested]: CPR_STATE_ENUM_LOCS.SPCprStateEnumRequested,
};
